// TableColumn 仅注册列配置，不产出可见 UI；保留空块便于主题覆盖入口
.#{$namespace}-table-column {
	display: none;
}
